import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreview() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
              <i className="ri-article-line"></i>
              最新资讯
            </div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
              资讯中心
            </h2>
          </div>
          <Link
            to="/articles"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2.5">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  {article.readCount} 阅读
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}